import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { config } from "../../services/configHeader";

const baseUrl = process.env.REACT_APP_BASE_URI;

const user = JSON.parse(localStorage.getItem("user_data")) || {};

const accountType = user?.account_type;
const config_ = {};
config_.headers = {
    "Authorization": `Bearer ${user?.token || "7fa5d115dbbf825a0a4abb2b2a7f37de"}`,
    "staffId": user?.staffId || null,
};

const configJson = {
    headers: {
        "Authorization": `Bearer ${user?.token || "7fa5d115dbbf825a0a4abb2b2a7f37de"}`,
        "Content-Type": "application/json",
        "staffId": user?.staffId || null,
    }
};

const normalizeThunkError = (error, fallbackMessage = "Request failed") => ({
    status: error?.response?.status || error?.status || 500,
    response: {
        data: {
            ...(error?.response?.data || {}),
            message:
                error?.response?.data?.message ||
                error?.message ||
                fallbackMessage,
            data: error?.response?.data?.data || null,
        },
    },
    message: error?.message || fallbackMessage,
});

// note : ancemnt == announcement ===============================
const initialState = {
    ancemntLoading: false,
    ancemntSuccess: false,
    ancemntError: false,
    ancemntMessage: null,
    ancemntData: null,

    ancemntLoadingOne: false,
    ancemntSuccessOne: false,
    ancemntErrorOne: false,
    ancemntMessageOne: null,
    ancemntDataOne: null,

    // Interaction endpoint state
    interactionLoading: false,
    interactionSuccess: false,
    interactionError: false,
    interactionMessage: null,
    interactionData: null,
    // 🐛 FIX: Accumulate counts per announcement ID in Redux state (avoids race condition)
    // Previously, multiple rapid get_counts responses would overwrite interactionData,
    // and the component's useEffect could only process the LAST one.
    // Now counts are merged directly in the reducer atomically.
    interactionCountsMap: {},

    ancemntGetLoading: false,
    ancemntGetSuccess: false,
    ancemntGetError: false,
    ancemntGetMessage: null,
    ancemntGetData: null,

    ancemntGetOneLoading: false,
    ancemntGetOneSuccess: false,
    ancemntGetOneError: false,
    ancemntGetOneMessage: null,
    ancemntGetOneData: null,

    ancemntGetTwoLoading: false,
    ancemntGetTwoSuccess: false,
    ancemntGetTwoError: false,
    ancemntGetTwoMessage: null,
    ancemntGetTwoData: null,

    ancemntGetThirdLoading: false,
    ancemntGetThirdSuccess: false,
    ancemntGetThirdError: false,
    ancemntGetThirdMessage: null,
    ancemntGetThirdData: null,

    ancemntGetFourthLoading: false,
    ancemntGetFourthSuccess: false,
    ancemntGetFourthError: false,
    ancemntGetFourthMessage: null,
    ancemntGetFourthData: null,

    ancemntGetFourthLoading: false,
    ancemntGetFourthSuccess: false,
    ancemntGetFourthError: false,
    ancemntGetFourthMessage: null,
    ancemntGetFourthData: null,

    ancemntNotificationLoading: false,
    ancemntNotificationLpoading: false,
    ancemntNotificationSuccess: false,
    ancemntNotificationError: false,
    ancemntNotificationMessage: null,
    ancemntNotificationData: null,

    notiCountLoading: false,
    notiCountLpoading: false,
    notiCountSuccess: false,
    notiCountError: false,
    notiCountMessage: null,
    notiCountData: null,

    ancmtTitleLoading: false,
    ancmtTitleLpoading: false,
    ancmtTitleSuccess: false,
    ancmtTitleError: false,
    ancmtTitleMessage: null,
    ancmtTitleData: null,

};

export const ancemntSaveData = createAsyncThunk(
    "ancemntSaveData",
    async (body) => {
        const { path, data } = body;
        const url = baseUrl + path;

        const result = {
            data: {
                status: 200,
                message: "Sorry, you can only view the data, not create it.",
                data: [],
            },
        };
return parseInt(accountType) === 2
            ? result
            : await axios
                .post(url, data, data instanceof FormData ? config_ : configJson)
                .then((response) => {
                    return response;
                })
                .catch((error) => {
                    if (!navigator.onLine) {
                        let data = {
                            response: {
                                data: [],
                                message: "No Internet Connection Found",
                                success: false,
                            },
                        };
                        return data;
                    } else {
                        return normalizeThunkError(error);
                    }
                });
    }
);

export const ancemntSaveDataOne = createAsyncThunk(
    "ancemntSaveDataOne",
    async (body) => {
        const { path, data } = body;
        const url = baseUrl + path;

        const result = {
            data: {
                status: 200,
                message: "Sorry, you can only view the data, not create it.",
                data: [],
            },
        };
        return parseInt(accountType) === 2
            ? result
            : await axios
                .post(url, data, data instanceof FormData ? config_ : configJson)
                .then((response) => {
                    return response;
                })
                .catch((error) => {
                    if (!navigator.onLine) {
                        let data = {
                            response: {
                                data: [],
                                message: "No Internet Connection Found",
                                success: false,
                            },
                        };
                        return data;
                    } else {
                        return normalizeThunkError(error);
                    }
                });
    }
);

export const ancemntGetData = createAsyncThunk("ancemntGetData", async (path) => {
    return await axios
        .get(`${baseUrl}${path}`, config)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            if (!navigator.onLine) {
                let data = {
                    response: {
                        data: [],
                        message: "No Internet Connection Found",
                        success: false,
                    },
                    message: "No Internet Connection Found",
                };
                return data;
            } else {
                return normalizeThunkError(error);
            }
        });
});

export const ancemntGetDataOne = createAsyncThunk(
    "ancemntGetDataOne",
    async (path) => {
        return await axios
            .get(`${baseUrl}${path}`, config)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                if (!navigator.onLine) {
                    let data = {
                        response: {
                            data: [],
                            message: "No Internet Connection Found",
                            success: false,
                        },
                        data: {
                            data: [],
                            message: "No Internet Connection Found",
                            success: false,
                        },
                        message: "No Internet Connection Found",
                    };
                    return data;
                } else {
                    return normalizeThunkError(error);
                }
            });
    }
);

export const ancemntGetDataTwo = createAsyncThunk(
    "ancemntGetDataTwo",
    async (path) => {
        return await axios
            .get(`${baseUrl}${path}`, config)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                if (!navigator.onLine) {
                    let data = {
                        response: {
                            data: [],
                            message: "No Internet Connection Found",
                            success: false,
                        },
                        data: {
                            data: [],
                            message: "No Internet Connection Found",
                            success: false,
                        },
                        message: "No Internet Connection Found",
                    };
                    return data;
                } else {
                    return normalizeThunkError(error);
                }
            });
    }
);

export const ancemntGetDataThird = createAsyncThunk(
    "ancemntGetDataThird",
    async (body) => {
        const { path, data } = body;
        const url = baseUrl + path;

        const result = {
            data: {
                status: 200,
                message: "Sorry, you can only view the data, not create it.",
                data: [],
            },
        };
        return parseInt(accountType) === 2
            ? result
            : await axios
                .post(url, data, configJson)   // ✅ JSON content-type
                .then((response) => {
                    return response;
                })
                .catch((error) => {
                    if (!navigator.onLine) {
                        let data = {
                            response: {
                                data: [],
                                message: "No Internet Connection Found",
                                success: false,
                            },
                        };
                        return data;
                    } else {
                        return error;
                    }
                });
    }
);

export const ancemntGetDataFourth = createAsyncThunk(
    "ancemntGetDataFourth",
    async (body) => {
        const { path, data } = body;
        const url = baseUrl + path;

        const result = {
            data: {
                status: 200,
                message: "Sorry, you can only view the data, not create it.",
                data: [],
            },
        };
        return parseInt(accountType) === 2
            ? result
            : await axios
                .post(url, data, configJson)   // ✅ JSON content-type
                .then((response) => {
                    return response;
                })
                .catch((error) => {
                    if (!navigator.onLine) {
                        let data = {
                            response: {
                                data: [],
                                message: "No Internet Connection Found",
                                success: false,
                            },
                        };
                        return data;
                    } else {
                        return error;
                    }
                });
    }
);

// export const ancemntNotification = createAsyncThunk(
//     "ancemntNotification",
//     async (path) => {
//         return await axios
//             .get(`${baseUrl}${path}`, config)
//             .then((response) => {
//                 return response;
//             })
//             .catch((error) => {
//                 if (!navigator.onLine) {
//                     let data = {
//                         response: {
//                             data: [],
//                             message: "No Internet Connection Found",
//                             success: false,
//                         },
//                         data: {
//                             data: [],
//                             message: "No Internet Connection Found",
//                             success: false,
//                         },
//                     };
//                     return data;
//                 } else {
//                     return error;
//                 }
//             });
//     }
// );

export const ancemntNotification = createAsyncThunk(
    "ancemntNotification",
    async (body) => {
        const { path, data } = body;
        const url = baseUrl + path;

        const result = {
            data: {
                status: 200,
                message: "Sorry, you can only view the data, not create it.",
                data: [],
            },
        };
        return parseInt(accountType) === 2
            ? result
            : await axios
                .post(url, data, configJson)
                .then((response) => {
                    return response;
                })
                .catch((error) => {
                    if (!navigator.onLine) {
                        let data = {
                            response: {
                                data: [],
                                message: "No Internet Connection Found",
                                success: false,
                            },
                        };
                        return data;
                    } else {
                        return error;
                    }
                });
    }
);

// Unified Interaction Endpoint (JSON)
export const announcementInteraction = createAsyncThunk(
    "announcementInteraction",
    async (body) => {
        const { path, data } = body;
        const url = baseUrl + path;

        return await axios
            .post(url, data, configJson)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                if (!navigator.onLine) {
                    return {
                        response: {
                            data: [],
                            message: "No Internet Connection Found",
                            success: false,
                        },
                    };
                } else {
                    return error;
                }
            });
    }
);

export const getAncemntNotiCountData = createAsyncThunk("getAncemntNotiCountData", async (path) => {
    return await axios
        .get(`${baseUrl}${path}`, config)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            if (!navigator.onLine) {
                let data = {
                    response: {
                        data: [],
                        message: "No Internet Connection Found",
                        success: false,
                    },
                    message: "No Internet Connection Found",
                };
                return data;
            } else {
                let data = {
                    response: {
                        data: {
                            message: error.message,
                        },
                    },
                };
                return error;
            }
        });
});

export const getAnnouncementTitle = createAsyncThunk("getAnnouncementTitle", async (path) => {
    return await axios
        .get(`${baseUrl}${path}`, config)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            if (!navigator.onLine) {
                let data = {
                    response: {
                        data: [],
                        message: "No Internet Connection Found",
                        success: false,
                    },
                    message: "No Internet Connection Found",
                };
                return data;
            } else {
                let data = {
                    response: {
                        data: {
                            message: error.message,
                        },
                    },
                };
                return error;
            }
        });
});

const ancemntSlice = createSlice({
    name: "ancemnt",
    initialState,

    reducers: {
        initState: (state) => {
            state.ancemntLoading = false;
            state.ancemntSuccess = false;
            state.ancemntError = false;
            state.ancemntMessage = null;
            state.ancemntData = null;

            state.ancemntGetLoading = false;
            state.ancemntGetSuccess = false;
            state.ancemntGetError = false;
            state.ancemntGetMessage = null;
            state.ancemntGetData = null;

            state.ancemntGetOneLoading = false;
            state.ancemntGetOneSuccess = false;
            state.ancemntGetOneError = false;
            state.ancemntGetOneMessage = null;
            state.ancemntGetOneData = null;

            state.ancemntGetTwoLoading = false;
            state.ancemntGetTwoSuccess = false;
            state.ancemntGetTwoError = false;
            state.ancemntGetTwoMessage = null;
            state.ancemntGetTwoData = null;

            state.ancemntGetThirdLoading = false;
            state.ancemntGetThirdSuccess = false;
            state.ancemntGetThirdError = false;
            state.ancemntGetThirdMessage = null;
            state.ancemntGetThirdData = null;
        },
        initAncemntState: (state) => {
            state.ancemntLoading = false;
            state.ancemntSuccess = false;
            state.ancemntError = false;
            state.ancemntMessage = null;
            state.ancemntData = null;

            state.ancemntLoadingOne = false;
            state.ancemntSuccessOne = false;
            state.ancemntErrorOne = false;
            state.ancemntMessageOne = null;
            state.ancemntDataOne = null;

            state.ancemntGetLoading = false;
            state.ancemntGetSuccess = false;
            state.ancemntGetError = false;
            state.ancemntGetMessage = null;
            state.ancemntGetData = null;

            state.ancemntGetOneLoading = false;
            state.ancemntGetOneSuccess = false;
            state.ancemntGetOneError = false;
            state.ancemntGetOneMessage = null;
            state.ancemntGetOneData = null;

            state.ancemntGetTwoLoading = false;
            state.ancemntGetTwoSuccess = false;
            state.ancemntGetTwoError = false;
            state.ancemntGetTwoMessage = null;
            state.ancemntGetTwoData = null;

            state.ancemntGetThirdLoading = false;
            state.ancemntGetThirdSuccess = false;
            state.ancemntGetThirdError = false;
            state.ancemntGetThirdMessage = null;
            state.ancemntGetThirdData = null;

            state.ancemntGetFourthLoading = false;
            state.ancemntGetFourthSuccess = false;
            state.ancemntGetFourthError = false;
            state.ancemntGetFourthMessage = null;
            state.ancemntGetFourthData = null;
        },

        initNotification: (state) => {
            state.ancemntNotificationLoading = false;
            state.ancemntNotificationLpoading = false;
            state.ancemntNotificationSuccess = false;
            state.ancemntNotificationError = false;
            state.ancemntNotificationMessage = null;
        },

        initNotiCountState: (state) => {
            state.notiCountLoading = false;
            state.notiCountLpoading = false;
            state.notiCountSuccess = false;
            state.notiCountError = false;
            state.notiCountMessage = null;
        },

        initAncmtTitleState: (state) => {
            state.ancmtTitleLoading = false;
            state.ancmtTitleLpoading = false;
            state.ancmtTitleSuccess = false;
            state.ancmtTitleError = false;
            state.ancmtTitleMessage = null;
        },

        initInteractionState: (state) => {
            state.interactionLoading = false;
            state.interactionSuccess = false;
            state.interactionError = false;
            state.interactionMessage = null;
            state.interactionData = null;
        }
    },

    extraReducers: (builder) => {
        builder.addCase(getAnnouncementTitle.pending, (state, action) => {
            state.ancmtTitleLoading = true;
            state.ancmtTitleSuccess = false;
            state.ancmtTitleError = false;
            state.ancmtTitleMessage = null;
            state.ancmtTitleData = null;
        });
        builder.addCase(getAnnouncementTitle.fulfilled, (state, action) => {
            const payload = action.payload || {};
            const body = payload.data || {};
            const responseBody = payload.response?.data || {};
            const status = payload.status;
            if (status == 200 || status == "200") {
                if (
                    body.status == true ||
                    body.status == "true"
                ) {
                    state.ancmtTitleLoading = false;
                    state.ancmtTitleSuccess = true;
                    state.ancmtTitleError = false;
                    state.ancmtTitleMessage = body.message || body.msg || null;
                    state.ancmtTitleData = body.data || null;
                } else {
                    state.ancmtTitleLoading = false;
                    state.ancmtTitleSuccess = false;
                    state.ancmtTitleError = true;
                    state.ancmtTitleMessage = body.message || body.msg || "Request failed";
                    state.ancmtTitleData = null;
                }
            } else {
                state.ancmtTitleLoading = false;
                state.ancmtTitleSuccess = false;
                state.ancmtTitleError = true;
                state.ancmtTitleMessage = responseBody.message || body.message || body.msg || payload.message || "Request failed";
                state.ancmtTitleData = responseBody.data || null;
            }
        });
        builder.addCase(getAnnouncementTitle.rejected, (state, action) => {
            state.ancmtTitleLoading = false;
            state.ancmtTitleSuccess = true;
            state.ancmtTitleError = false;
            state.ancmtTitleMessage = null;
            state.ancmtTitleData = null;
        });
        // -------------------------------------------------

        builder.addCase(getAncemntNotiCountData.pending, (state, action) => {
            state.notiCountLoading = true;
            state.notiCountSuccess = false;
            state.notiCountError = false;
            state.notiCountMessage = null;
            state.notiCountData = null;
        });
        builder.addCase(getAncemntNotiCountData.fulfilled, (state, action) => {
            const payload = action.payload || {};
            const body = payload.data || {};
            const responseBody = payload.response?.data || {};
            const status = payload.status;
            if (status == 200 || status == "200") {
                if (
                    body.status == true ||
                    body.status == "true"
                ) {
                    state.notiCountLoading = false;
                    state.notiCountSuccess = true;
                    state.notiCountError = false;
                    state.notiCountMessage = body.message || body.msg || null;
                    state.notiCountData = body.data || null;
                } else {
                    state.notiCountLoading = false;
                    state.notiCountSuccess = false;
                    state.notiCountError = true;
                    state.notiCountMessage = body.message || body.msg || "Request failed";
                    state.notiCountData = null;
                }
            } else {
                state.notiCountLoading = false;
                state.notiCountSuccess = false;
                state.notiCountError = true;
                state.notiCountMessage = responseBody.message || body.message || body.msg || payload.message || "Request failed";
                state.notiCountData = responseBody.data || null;
            }
        });
        builder.addCase(getAncemntNotiCountData.rejected, (state, action) => {
            state.ancemntNotificationLoading = false;
            state.ancemntNotificationSuccess = true;
            state.ancemntNotificationError = false;
            state.ancemntNotificationMessage = null;
            state.ancemntNotificationData = null;
        });
        // -------------------------------------------------

        builder.addCase(ancemntNotification.pending, (state, action) => {
            state.ancemntNotificationLoading = true;
            state.ancemntNotificationSuccess = false;
            state.ancemntNotificationError = false;
            state.ancemntNotificationMessage = null;
            state.ancemntNotificationData = null;
        });
        builder.addCase(ancemntNotification.fulfilled, (state, action) => {
            const payload = action.payload || {};
            const body = payload.data || {};
            const responseBody = payload.response?.data || {};
            const status = payload.status;
            if (status == 200 || status == "200") {
                if (
                    body.status == true ||
                    body.status == "true"
                ) {
                    state.ancemntNotificationLoading = false;
                    state.ancemntNotificationSuccess = true;
                    state.ancemntNotificationError = false;
                    state.ancemntNotificationMessage = body.message || body.msg || null;
                    state.ancemntNotificationData = body.data || null;
                } else {
                    state.ancemntNotificationLoading = false;
                    state.ancemntNotificationSuccess = false;
                    state.ancemntNotificationError = true;
                    state.ancemntNotificationMessage = body.message || body.msg || "Request failed";
                    state.ancemntNotificationData = null;
                }
            } else {
                state.ancemntNotificationLoading = false;
                state.ancemntNotificationSuccess = false;
                state.ancemntNotificationError = true;
                state.ancemntNotificationMessage = responseBody.message || body.message || body.msg || payload.message || "Request failed";
                state.ancemntNotificationData = responseBody.data || null;
            }
        });
        builder.addCase(ancemntNotification.rejected, (state, action) => {
            state.ancemntNotificationLoading = false;
            state.ancemntNotificationSuccess = true;
            state.ancemntNotificationError = false;
            state.ancemntNotificationMessage = null;
            state.ancemntNotificationData = null;
        });
        // -------------------------------------------------

        builder.addCase(ancemntGetData.pending, (state, action) => {
            state.ancemntGetLoading = true;
            state.ancemntGetSuccess = false;
            state.ancemntGetError = false;
            state.ancemntGetMessage = null;
            state.ancemntGetData = null;
        });
        builder.addCase(ancemntGetData.fulfilled, (state, action) => {
            const status = action.payload.status;
            if (status == 200 || status == "200") {
                if (
                    action.payload.data.status == true ||
                    action.payload.data.status == "true"
                ) {
                    state.ancemntGetLoading = false;
                    state.ancemntGetSuccess = true;
                    state.ancemntGetError = false;
                    state.ancemntGetMessage = action.payload.data.message;
                    state.ancemntGetData = action.payload.data.data;
                } else {
                    state.ancemntGetLoading = false;
                    state.ancemntGetSuccess = false;
                    state.ancemntGetError = true;
                    state.ancemntGetMessage = action.payload.data.message
                        ? action.payload.data.message
                        : action.payload.data.msg;
                    state.ancemntGetData = null;
                }
            } else {
                state.ancemntGetLoading = false;
                state.ancemntGetSuccess = false;
                state.ancemntGetError = true;
                state.ancemntGetMessage = action.payload.response.data.message;
                state.ancemntGetData = action.payload.response.data.data;
            }
        });
        builder.addCase(ancemntGetData.rejected, (state, action) => {
            state.ancemntGetLoading = false;
            state.ancemntGetSuccess = true;
            state.ancemntGetError = false;
            state.ancemntGetMessage = null;
            state.ancemntGetData = null;
        });
        // -------------------------------------------------

        builder.addCase(ancemntGetDataOne.pending, (state, action) => {
            state.ancemntGetOneLoading = true;
            state.ancemntGetOneSuccess = false;
            state.ancemntGetOneError = false;
            state.ancemntGetOneMessage = null;
            state.ancemntGetOneData = null;
        });
        builder.addCase(ancemntGetDataOne.fulfilled, (state, action) => {
            const status = action.payload.status;
            if (status == 200) {
                if (
                    action.payload.data.status == true ||
                    action.payload.data.status == "true"
                ) {
                    state.ancemntGetOneLoading = false;
                    state.ancemntGetOneSuccess = true;
                    state.ancemntGetOneError = false;
                    state.ancemntGetOneMessage = action.payload.data.message;
                    state.ancemntGetOneData = action.payload.data.data;
                } else {
                    // con
                    state.ancemntGetOneLoading = false;
                    state.ancemntGetOneSuccess = false;
                    state.ancemntGetOneError = true;
                    // state.ancemntGetOneMessage = action.payload.data.message
                    //   ? action.payload.data.message
                    //   : action.payload.response.data.message;
                    state.ancemntGetOneData = null;
                }
            }
        });
        builder.addCase(ancemntGetDataOne.rejected, (state, action) => {
            state.ancemntGetOneLoading = false;
            state.ancemntGetOneSuccess = true;
            state.ancemntGetOneError = false;
            state.ancemntGetOneMessage = null;
            state.ancemntGetOneData = null;
        });

        // -------------------------------------------------
        builder.addCase(ancemntGetDataTwo.pending, (state, action) => {
            state.ancemntGetTwoLoading = true;
            state.ancemntGetTwoSuccess = false;
            state.ancemntGetTwoError = false;
            state.ancemntGetTwoMessage = null;
            state.ancemntGetTwoData = null;
        });
        builder.addCase(ancemntGetDataTwo.fulfilled, (state, action) => {
            const status = action.payload.status;
            if (status == 200) {
                if (
                    action.payload.data.status == true ||
                    action.payload.data.status == "true"
                ) {
                    state.ancemntGetTwoLoading = false;
                    state.ancemntGetTwoSuccess = true;
                    state.ancemntGetTwoError = false;
                    state.ancemntGetTwoMessage = action.payload.data.message;
                    state.ancemntGetTwoData = action.payload.data.data;
                } else {
                    state.ancemntGetTwoLoading = false;
                    state.ancemntGetTwoSuccess = false;
                    state.ancemntGetTwoError = true;
                    state.ancemntGetTwoMessage = "";
                    state.ancemntGetTwoData = null;
                }
            } else {
                state.ancemntGetTwoLoading = false;
                state.ancemntGetTwoSuccess = false;
                state.ancemntGetTwoError = true;
                // state.ancemntGetTwoMessage = action.payload.data.message;
                state.ancemntGetTwoMessage = "";
                state.ancemntGetTwoData = null;
            }
        });
        builder.addCase(ancemntGetDataTwo.rejected, (state, action) => {
            state.ancemntGetTwoLoading = false;
            state.ancemntGetTwoSuccess = false;
            state.ancemntGetTwoError = true;
            state.ancemntGetTwoMessage = null;
            state.ancemntGetTwoData = null;
        });
        // -------------------------------------------------

        builder.addCase(ancemntGetDataThird.pending, (state, action) => {
            state.ancemntGetThirdLoading = true;
            state.ancemntGetThirdSuccess = false;
            state.ancemntGetThirdError = false;
            state.ancemntGetThirdMessage = null;
            state.ancemntGetThirdData = null;
        });
        builder.addCase(ancemntGetDataThird.fulfilled, (state, action) => {
            if (action.payload.status == 200 || action.payload.status == 201) {
                if (
                    action.payload.data.status == true ||
                    action.payload.data.status == "true"
                ) {
                    state.ancemntGetThirdLoading = false;
                    state.ancemntGetThirdSuccess = accountType == 2 ? false : true;
                    state.ancemntGetThirdError = accountType == 2 ? true : false;
                    state.ancemntGetThirdMessage = action.payload.data.message;
                    state.ancemntGetThirdData = action.payload.data.data;
                } else {
                    state.ancemntGetThirdLoading = false;
                    state.ancemntGetThirdSuccess = false;
                    state.ancemntGetThirdError = true;
                    state.ancemntGetThirdMessage =
                        action.payload.data.msg == undefined
                            ? action.payload.data.message
                            : action.payload.data.msg;
                }
            } else {
                state.ancemntGetThirdLoading = false;
                state.ancemntGetThirdSuccess = false;
                state.ancemntGetThirdError = true;
                state.ancemntGetThirdMessage =
                    accountType == 2
                        ? action.payload?.data?.message
                        : action.payload?.response?.data?.message
                            ? action.payload?.response?.data?.message
                            : action.payload.message;
                state.ancemntGetThirdData = null;
            }
        });
        builder.addCase(ancemntGetDataThird.rejected, (state, action) => {
            state.ancemntGetThirdLoading = false;
            state.ancemntGetThirdSuccess = true;
            state.ancemntGetThirdError = false;
            state.ancemntGetThirdMessage = null;
            state.ancemntGetThirdData = null;
        });
        // -------------------------------------------------

        builder.addCase(ancemntGetDataFourth.pending, (state, action) => {
            state.ancemntGetFourthLoading = true;
            state.ancemntGetFourthSuccess = false;
            state.ancemntGetFourthError = false;
            state.ancemntGetFourthMessage = null;
            state.ancemntGetFourthData = null;
        });
        builder.addCase(ancemntGetDataFourth.fulfilled, (state, action) => {
            if (action.payload.status == 200 || action.payload.status == 201) {
                if (
                    action.payload.data.status == true ||
                    action.payload.data.status == "true"
                ) {
                    state.ancemntGetFourthLoading = false;
                    state.ancemntGetFourthSuccess = accountType == 2 ? false : true;
                    state.ancemntGetFourthError = accountType == 2 ? true : false;
                    state.ancemntGetFourthMessage = action.payload.data.message;
                    state.ancemntGetFourthData = action.payload.data.data;
                } else {
                    state.ancemntGetFourthLoading = false;
                    state.ancemntGetFourthSuccess = false;
                    state.ancemntGetFourthError = true;
                    state.ancemntGetFourthMessage =
                        action.payload.data.msg == undefined
                            ? action.payload.data.message
                            : action.payload.data.msg;
                }
            } else {
                state.ancemntGetFourthLoading = false;
                state.ancemntGetFourthSuccess = false;
                state.ancemntGetFourthError = true;
                state.ancemntGetFourthMessage =
                    accountType == 2
                        ? action.payload?.data?.message
                        : action.payload?.response?.data?.message
                            ? action.payload?.response?.data?.message
                            : action.payload.message;
                state.ancemntGetFourthData = null;
            }
        });
        builder.addCase(ancemntGetDataFourth.rejected, (state, action) => {
            state.ancemntGetFourthLoading = false;
            state.ancemntGetFourthSuccess = true;
            state.ancemntGetFourthError = false;
            state.ancemntGetFourthMessage = null;
            state.ancemntGetFourthData = null;
        });
        // -------------------------------------------------

        builder.addCase(ancemntSaveData.pending, (state) => {
            state.ancemntLoading = true;
            state.ancemntSuccess = false;
            state.ancemntError = false;
            state.ancemntMessage = null;
            state.ancemntData = null;
        });
        builder.addCase(ancemntSaveData.fulfilled, (state, action) => {
            if (action.payload.status == 200 || action.payload.status == 201) {
                if (
                    action.payload.data.status == true ||
                    action.payload.data.status == "true"
                ) {
                    state.ancemntLoading = false;
                    state.ancemntSuccess = accountType == 2 ? false : true;
                    state.ancemntError = accountType == 2 ? true : false;
                    state.ancemntMessage = action.payload.data.message;
                    state.ancemntData = action.payload.data.data;
                } else {
                    state.ancemntLoading = false;
                    state.ancemntSuccess = false;
                    state.ancemntError = true;
                    state.ancemntMessage =
                        action.payload.data.msg == undefined
                            ? action.payload.data.message
                            : action.payload.data.msg;
                }
            } else {
                state.ancemntLoading = false;
                state.ancemntSuccess = false;
                state.ancemntError = true;
                state.ancemntMessage =
                    accountType == 2
                        ? action.payload?.data?.message
                        : action.payload?.response?.data?.message
                            ? action.payload?.response?.data?.message
                            : action.payload.message;
                state.ancemntData = null;
            }
        });
        builder.addCase(ancemntSaveData.rejected, (state) => {
            state.ancemntLoading = false;
            state.ancemntSuccess = false;
            state.ancemntError = true;
            state.ancemntMessage = null;
            state.ancemntData = null;
        });
        // -------------------------------------------------

        builder.addCase(ancemntSaveDataOne.pending, (state) => {
            state.ancemntLoadingOne = true;
            state.ancemntSuccessOne = false;
            state.ancemntErrorOne = false;
            state.ancemntMessageOne = null;
            state.ancemntDataOne = null;
        });
        builder.addCase(ancemntSaveDataOne.fulfilled, (state, action) => {
            if (action.payload.status == 200 || action.payload.status == 201) {
                if (
                    action.payload.data.status == true ||
                    action.payload.data.status == "true"
                ) {
                    state.ancemntLoadingOne = false;
                    state.ancemntSuccessOne = accountType == 2 ? false : true;
                    state.ancemntErrorOne = accountType == 2 ? true : false;
                    state.ancemntMessageOne = action.payload.data.message;
                    state.ancemntDataOne = action.payload.data.data;
                } else {
                    state.ancemntLoadingOne = false;
                    state.ancemntSuccessOne = false;
                    state.ancemntErrorOne = true;
                    state.ancemntMessageOne =
                        action.payload.data.msg == undefined
                            ? action.payload.data.message
                            : action.payload.data.msg;
                }
            } else {
                state.ancemntLoadingOne = false;
                state.ancemntSuccessOne = false;
                state.ancemntErrorOne = true;
                state.ancemntMessageOne =
                    accountType == 2
                        ? action.payload.data.message
                        : action.payload.response.data.message;
                state.ancemntDataOne = null;
            }
        });
        builder.addCase(ancemntSaveDataOne.rejected, (state) => {
            state.ancemntLoadingOne = false;
            state.ancemntSuccessOne = false;
            state.ancemntErrorOne = true;
            state.ancemntMessageOne = null;
            state.ancemntDataOne = null;
        });
        // Interaction endpoint handlers
        builder.addCase(announcementInteraction.pending, (state) => {
            state.interactionLoading = true;
            state.interactionSuccess = false;
            state.interactionError = false;
            state.interactionMessage = null;
            state.interactionData = null;
        });
        builder.addCase(announcementInteraction.fulfilled, (state, action) => {
            const status = action.payload.status;
            if (status == 200 || status == "200") {
                if (
                    action.payload.data.status == true ||
                    action.payload.data.status == "true"
                ) {
                    state.interactionLoading = false;
                    state.interactionSuccess = true;
                    state.interactionError = false;
                    state.interactionMessage = action.payload.data.message;
                    
                    // Get the raw response data
                    let responseData = action.payload.data.data || action.payload.data;
                    
                    // Get request meta fields
                    const requestMetaId = action.meta?.arg?.data?._meta_id;
                    const requestMetaAction = action.meta?.arg?.data?._meta_action;
                    
                    // 🐛 FIX: Accumulate counts atomically in the reducer to avoid race conditions.
                    // When multiple get_counts requests complete simultaneously, each one overwrites
                    // interactionData, and the component's useEffect can only process the last one.
                    // Instead, we merge counts into interactionCountsMap right here in the reducer.
                    if (requestMetaAction === "get_counts" && requestMetaId && responseData && typeof responseData === 'object') {
                        state.interactionCountsMap = {
                            ...state.interactionCountsMap,
                            [requestMetaId]: {
                                likes: responseData.likes || 0,
                                dislikes: responseData.dislikes || 0,
                                comments: responseData.comments || 0,
                                shares: responseData.shares || 0,
                                user_reaction: responseData.user_reaction || null,
                            }
                        };
                    }
                    
                    if ((requestMetaId || requestMetaAction) && responseData && typeof responseData === 'object' && !Array.isArray(responseData)) {
                        responseData = {
                            ...responseData,
                            _meta_id: requestMetaId,
                            _meta_action: requestMetaAction,
                        };
                    }
                    
                    state.interactionData = responseData;
                } else {
                    state.interactionLoading = false;
                    state.interactionSuccess = false;
                    state.interactionError = true;
                    state.interactionMessage = action.payload.data.message || action.payload.data.msg;
                    state.interactionData = null;
                }
            } else {
                state.interactionLoading = false;
                state.interactionSuccess = false;
                state.interactionError = true;
                state.interactionMessage = action.payload.response?.data?.message || "Unknown error";
                state.interactionData = null;
            }
        });
        builder.addCase(announcementInteraction.rejected, (state) => {
            state.interactionLoading = false;
            state.interactionSuccess = false;
            state.interactionError = true;
            state.interactionMessage = null;
            state.interactionData = null;
        });
    },
});

export const { initState, initAncemntState, initNotification, initNotiCountState, initAncmtTitleState, initInteractionState } =
    ancemntSlice.actions;

export default ancemntSlice.reducer;
